<template>
  <div class="sidebar sidebar-colors">
    <div class="sidebar__wrapper">
      <div v-if="!loading" class="servers-list-cont">
        <div
          class="sidebar-title__wrapper title sidebar-item"
          :class="{ selected: currentServerIdx == -1 }"
          @click="selectCommon"
        >
          Servers
        </div>
        <div class="servers-list__wrapper">
          <div class="servers-list">
            <div
              v-for="(s, idx) in servers"
              :key="s.id"
              class="server-row sidebar-item"
              :class="{ selected: idx == currentServerIdx }"
              @click="selectServer(idx)"
            >
              <span class="server-link"> {{ s.name }} </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Loader -->
      <div v-else class="loader-container">
        <circle2
          color="var(--sidebar-bg-color)"
          background="var(--navbar-bg-color)"
          stroke="4px"
          size="60px"
        ></circle2>
      </div>
      <!-- Collapse button -->
      <div class="sidebar-collapser">
        <span v-if="collapsed" @click="$emit('update:collapsed', false)">
          <arrow-right-bold-circle class="action-icon" :size="30" />
        </span>
        <span v-else @click="$emit('update:collapsed', true)">
          <arrow-left-bold-circle class="action-icon" :size="30" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle2 } from "vue-loading-spinner";
import ArrowLeftBoldCircle from "vue-material-design-icons/ArrowLeftBoldCircle.vue";
import ArrowRightBoldCircle from "vue-material-design-icons/ArrowRightBoldCircle.vue";

// @group Admin Page
// Sidebar servers list
export default {
  name: "AdminSidebar",
  components: {
    Circle2,
    ArrowLeftBoldCircle,
    ArrowRightBoldCircle
  },
  props: {
    // servers information
    servers: {
      type: Array,
      required: true
    },
    // selected server object
    selectedServer: {
      type: Object,
      default: null
    },
    // is sidebar in loading state
    loading: {
      type: Boolean,
      default: false
    },
    // is sidebar collapsed or not
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** selected server index */
      currentServerIdx: -1
    };
  },
  watch: {
    // @vuese
    // Update selected server tab index
    selectedServer() {
      if (this.selectedServer == null) {
        /** highlight title */
        this.currentServerIdx = -1;
      } else {
        /** highlight selected server name */
        this.currentServerIdx = this.servers.findIndex(
          s => s.id == this.selectedServer.id
        );
      }
    }
  },
  methods: {
    // @vuese
    // Change selected server
    // @arg idx - new selected server's index
    selectServer(idx) {
      const server = this.servers[idx];
      // Server selected
      this.$emit("serverSelected", { server: server });
    },
    // @vuese
    // Cancel server selecting
    selectCommon() {
      this.currentServerIdx = -1;
      // All servers tab selected
      this.$emit("commonSelected");
    }
  }
};
</script>

<style scoped>
.sidebar {
  height: 100%;
}
.sidebar-colors {
  background-color: var(--sidebar-bg-color);
}
.sidebar__wrapper {
  height: 100%;
  padding: 24px 24px;
  box-sizing: border-box;
}

.servers-list-cont {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.sidebar-title__wrapper {
  padding-bottom: 0.5em;
}
.title {
  /** long name ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selected.title,
.title:hover {
  color: var(--sidebar-sel-font-color);
}

.servers-list__wrapper {
  height: 100%;
}
.sidebar-item {
  cursor: pointer;
  transition: color var(--fast-transition),
    background-color var(--fast-transition);

  /** long text ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.server-list {
  display: flex;
  flex-direction: column;
}

.server-row {
  padding-left: 0.5em;
  padding-bottom: 0.15em;
  padding-top: 0.15em;
  margin-bottom: 2px;

  border-radius: 5px;
}
.server-row:hover,
.server-row.selected {
  background-color: var(--sidebar-sel-bg-color);
  color: var(--sidebar-sel-font-color);
}

.loader-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-icon {
  cursor: pointer;
  color: var(--sidebar-sel-bg-color);
}
.action-icon:hover {
  color: var(--navbar-bg-color);
}

@media only screen and (max-width: 991px) {
  .sidebar__wrapper {
    display: flex;
    padding-right: 12px;
  }
  .servers-list-cont,
  .loader-container {
    flex-grow: 1;
  }
  .sidebar-collapser {
    width: 20px;
    display: flex;
    justify-content: flex-end;
  }
  .servers-list__wrapper {
    padding-right: 1em;
  }
}
@media only screen and (min-width: 992px) {
  .sidebar-collapser {
    display: none;
  }
}
</style>
